<template>
  <v-navigation-drawer
    v-model="model"
    class="grey darken-4 sidebar"
    dark
    stateless
    app
    width="280"
  >
    <div class="sidebar-logo">
      <img
        src="/img/logo.svg"
        height="52"
        alt=""
      >
    </div>
    <v-divider />
    <v-list
      flat
      dark
      class="sidebar-menu"
    >
      <v-list-item-group
        v-model="selectedItem"
        color="amber darken-3"
      >
        <template v-for="(item, index) in routes">
          <v-list-group
            v-if="item.children.length"
            :key="`group-${index}`"
            :value="$route.path.indexOf(item.route) != -1"
            :prepend-icon="item.icon"
            color="amber darken-3"
          >
            <template #activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="children in item.children"
              :key="`group-${index}-${children.title}`"
              :to="children.to"
            >
              <v-list-item-title
                class="pl-5"
                v-text="children.title"
              />
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="`item-${index}`"
            :to="item.to"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import routes from '@/router/menu.js';

export default {
  props: {
    value: {
      type: Boolean,
    },
  },
  data: () => ({
    selectedItem: 1,
    routes: [],
  }),

  computed: {
    model: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      },
    },
  },

  mounted() {
    this.routes = routes;
  },
};
</script>

<style lang="scss">

.sidebar {
  .v-navigation-drawer__border {
    display: none;
  }
}

.sidebar-logo {
  padding: 10px 0 5px 10px;
}

.sidebar-menu {
  font-weight: bold;
}

.default-wrapper {
  max-width: 1100px;
}

</style>
